import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.MESSAGES_COUNT_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.MESSAGES_COUNT_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.MESSAGES_COUNT_FAILURE:
      return {
        data: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
